import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface LandingPageHeroChicletCtaTextProps {
  readonly label: MessageKey;
}

const LandingPageHeroChicletCtaText = ({
  label,
}: LandingPageHeroChicletCtaTextProps) => {
  const t = useTranslations();

  return (
    <Typography
      className="leading-none"
      color="light"
      Element="span"
      variant="body-small"
      weight="bold"
    >
      {t(label)}
    </Typography>
  );
};

export default LandingPageHeroChicletCtaText;
